<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <div v-else>
            <div class="d-flex align-items-center justify-content-between mb-4">
                <div>
                    <h4 class="page-header-title">Edit Gadai Elektronik</h4>
                    <span class="page-header-subtitle">Ubah data barang gadai dan ajukan persetujuan KCS.</span>
                </div>
            </div>

            <b-form @submit.prevent="openModalConfirm">
                <!-- DATA TRANSAKSI -->
                <div class="section-card">
                    <div class="section-card-header">
                        <span class="section-card-title">DATA TRANSAKSI</span>
                    </div>
                    <div class="section-card-body">
                        <div class="member-info-panel">
                            <b-row>
                                <b-col md="6">
                                    <div class="member-item-row">
                                        <span class="member-item-label font-weight-bold">No. Faktur</span>
                                        <span class="member-item-value font-weight-bold text-dark" v-if="dataElek.noFaktur != null">{{ dataElek.noFaktur }}</span>
                                        <span class="member-item-value" v-else>-</span>
                                    </div>
                                </b-col>
                                <b-col md="6">
                                    <div class="member-item-row">
                                        <span class="member-item-label">Status Gadai</span>
                                        <span class="member-item-value font-weight-bold" v-if="dataElek.statusGadai != null">{{ dataElek.statusGadai }}</span>
                                        <span class="member-item-value" v-else>-</span>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                    </div>
                </div>

                <!-- DATA ANGGOTA -->
                <div class="section-card">
                    <div class="section-card-header">
                        <span class="section-card-title">DATA ANGGOTA</span>
                    </div>
                    <div class="section-card-body">
                        <div class="member-info-panel">
                            <b-row>
                                <b-col md="6">
                                    <div class="member-item-row">
                                        <span class="member-item-label">No. Anggota</span>
                                        <span class="member-item-value font-weight-bold" v-if="dataElek.anggota.noAnggota != null">{{ dataElek.anggota.noAnggota }}</span>
                                        <span class="member-item-value" v-else>-</span>
                                    </div>
                                    <div class="member-item-row">
                                        <span class="member-item-label">No. Identitas</span>
                                        <span class="member-item-value" v-if="dataElek.anggota.noIdentitas != null">{{ dataElek.anggota.noIdentitas }}</span>
                                        <span class="member-item-value" v-else>-</span>
                                    </div>
                                    <div class="member-item-row">
                                        <span class="member-item-label">No. Handphone</span>
                                        <span class="member-item-value" v-if="dataElek.anggota.noHp != null">{{ dataElek.anggota.noHp }}</span>
                                        <span class="member-item-value" v-else>-</span>
                                    </div>
                                    <div class="member-item-row">
                                        <span class="member-item-label">Alamat</span>
                                        <span class="member-item-value" v-if="dataElek.anggota.alamat != null">{{ dataElek.anggota.alamat }}</span>
                                        <span class="member-item-value" v-else>-</span>
                                    </div>
                                </b-col>
                                <b-col md="6">
                                    <div class="member-item-row">
                                        <span class="member-item-label">Jenis Identitas</span>
                                        <span class="member-item-value" v-if="dataElek.anggota.jenisIdentitas != null">{{ dataElek.anggota.jenisIdentitas }}</span>
                                        <span class="member-item-value" v-else>-</span>
                                    </div>
                                    <div class="member-item-row">
                                        <span class="member-item-label">Nama</span>
                                        <span class="member-item-value" v-if="dataElek.anggota.namaAnggota != null">{{ dataElek.anggota.namaAnggota }}</span>
                                        <span class="member-item-value" v-else>-</span>
                                    </div>
                                    <div class="member-item-row">
                                        <span class="member-item-label">No. Rumah</span>
                                        <span class="member-item-value" v-if="dataElek.anggota.noRumah != null">{{ dataElek.anggota.noRumah }}</span>
                                        <span class="member-item-value" v-else>-</span>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                    </div>
                </div>

                <!-- DATA BARANG -->
                <div class="section-card">
                    <div class="section-card-header">
                        <span class="section-card-title">DATA BARANG</span>
                    </div>
                    <div class="section-card-body">
                        <b-row>
                            <b-col md="4">
                                <b-form-group label="Jenis Barang">
                                    <b-form-select v-model="dataElek.barang.jenis" name="gadaiJenisBarang" required>
                                        <template v-slot:first>
                                            <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                                            <b-form-select-option v-for="(item, idx) in optElekJenis" v-bind:value="{ id: item.id, name: item.name }" v-bind:key="idx">
                                                {{ item.name }}
                                            </b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                            <b-col md="4">
                                <b-form-group label="Merk Barang">
                                    <b-form-select v-model="dataElek.barang.merk" name="gadaiMerkBarang" required>
                                        <template v-slot:first>
                                            <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                                            <b-form-select-option v-for="(item, idx) in optElekMerk" v-bind:value="{ id: item.id, name: item.name }" v-bind:key="idx">
                                                {{ item.name }}
                                            </b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                            <b-col md="4">
                                <b-form-group label="Tipe">
                                    <b-form-select v-model="dataElek.barang.tipe" name="gadaiTipeBarang" required>
                                        <template v-slot:first>
                                            <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                                            <b-form-select-option v-for="(item, idx) in optElekTipe" v-bind:value="{ id: item.id, name: item.name }" v-bind:key="idx">
                                                {{ item.name }}
                                            </b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col md="4" v-if="optElekTahun.length != 0">
                                <b-form-group label="Tahun">
                                    <b-form-select v-model="input.tahunGadai" name="gadaiTahunElektronik" required>
                                        <template v-slot:first>
                                            <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                                            <b-form-select-option v-for="(item, idx) in optElekTahun" v-bind:value="{ id: item.id, name: item.name }" v-bind:key="idx">
                                                {{ item.name }}
                                            </b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                            <b-col :md="optElekTahun.length != 0 ? '4' : '6'">
                                <b-form-group label="Kondisi / Grade Barang">
                                    <b-form-select v-model="input.dataKondisi" name="gadaiGradeBarangClass" :options="optElekKondisi" required>
                                        <template v-slot:first>
                                            <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                            <b-col :md="optElekTahun.length != 0 ? '4' : '6'">
                                <b-form-group label="Warna">
                                    <b-form-select v-model="dataElek.barang.warna.id" name="gadaiWarnaBarang" :options="optElekWarna" required>
                                        <template v-slot:first>
                                            <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col md="6">
                                <b-form-group label="No. Imei/ SN">
                                    <b-form-input v-model="dataElek.barang.noImei" name="gadaiNoImei" required></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Password" description="Bila barang gadai tidak menggunakan password, input ini dapat dikosongkan.">
                                    <b-form-input v-model="dataElek.barang.password" name="gadaiPassword"></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-form-group label="Kondisi/ Kerusakan/ Keterangan Lainnya">
                            <b-form-textarea
                                id="textarea"
                                v-model="dataElek.barang.keterangan" name="gadaiKondisi"
                                rows="3"
                                max-rows="6"
                            ></b-form-textarea>
                            <span class="small text-muted">
                                * Dapat digunakan juga untuk mencatat detil barang gadai bilamana barang tidak ditemukan (Menggunakan pilihan ‘Lainnya’)
                            </span>
                        </b-form-group>

                        <b-form-group label="Kelengkapan Barang">
                            <div v-if="optKelengkapanBarang.length == 0" class="text-muted small">
                                Tidak ada kelengkapan dari jenis barang yang dipilih.
                            </div>
                            <b-form-checkbox-group class="custom-checkbox-pill-group" v-else v-model="input.kelengkapanGadai" name="gadaiKelengkapanBarang">
                                <b-form-checkbox v-for="item in optKelengkapanBarang" v-bind:key="item.id" :value="{ id: item.id, name: item.name }">
                                    {{ item.name }}
                                </b-form-checkbox>
                            </b-form-checkbox-group>
                        </b-form-group>

                        <b-row class="mt-4">
                            <b-col md="6">
                                <label class="font-weight-bold text-dark d-block mb-2" style="font-size: 13px;">Spesifikasi Barang (Jenis)</label>
                                <div class="mb-2">
                                    <span class="text-muted small font-weight-bold d-block mb-1">Penambahan</span>
                                    <div v-if="optElekSpekJenis.penambahan.length == 0" class="text-muted small mb-2">
                                        Tidak ada penambahan spesifikasi dari jenis barang yang dipilih.
                                    </div>
                                    <b-form-checkbox-group class="checkbox-group" v-else v-model="input.spesifikasiJenis" name="gadaiPenambahanSpekJenisBarang">
                                        <b-form-checkbox class="d-block mb-1" v-for="item in optElekSpekJenis.penambahan" v-bind:key="item.id" :value="item.id">
                                            {{ item.name }}
                                        </b-form-checkbox>
                                    </b-form-checkbox-group>
                                </div>
                                <div>
                                    <span class="text-muted small font-weight-bold d-block mb-1">Pengurangan</span>
                                    <div v-if="optElekSpekJenis.pengurangan.length == 0" class="text-muted small mb-2">
                                        Tidak ada pengurangan spesifikasi dari jenis barang yang dipilih.
                                    </div>
                                    <b-form-checkbox-group class="checkbox-group" v-else v-model="input.spesifikasiJenis" name="gadaiPenguranganSpekJenisBarang">
                                        <b-form-checkbox class="d-block mb-1" v-for="item in optElekSpekJenis.pengurangan" v-bind:key="item.id" :value="item.id">
                                            {{ item.name }}
                                        </b-form-checkbox>
                                    </b-form-checkbox-group>
                                </div>
                            </b-col>
                            <b-col md="6">
                                <label class="font-weight-bold text-dark d-block mb-2" style="font-size: 13px;">Spesifikasi Barang (Merk)</label>
                                <div class="mb-2">
                                    <span class="text-muted small font-weight-bold d-block mb-1">Penambahan</span>
                                    <div v-if="optElekSpekMerk.penambahan.length == 0" class="text-muted small mb-2">
                                        Tidak ada penambahan spesifikasi dari merk barang yang dipilih.
                                    </div>
                                    <b-form-checkbox-group class="checkbox-group" v-else v-model="input.spesifikasiMerk" name="gadaiPenambahanSpekMerkBarangElek">
                                        <b-form-checkbox class="d-block mb-1" v-for="item in optElekSpekMerk.penambahan" v-bind:key="item.id" :value="item.id">
                                            {{ item.name }}
                                        </b-form-checkbox>
                                    </b-form-checkbox-group>
                                </div>
                                <div>
                                    <span class="text-muted small font-weight-bold d-block mb-1">Pengurangan</span>
                                    <div v-if="optElekSpekMerk.pengurangan.length == 0" class="text-muted small mb-2">
                                        Tidak ada pengurangan spesifikasi dari merk barang yang dipilih.
                                    </div>
                                    <b-form-checkbox-group class="checkbox-group" v-else v-model="input.spesifikasiMerk" name="gadaiPenguranganSpekMerkBarangElek">
                                        <b-form-checkbox class="d-block mb-1" v-for="item in optElekSpekMerk.pengurangan" v-bind:key="item.id" :value="item.id">
                                            {{ item.name }}
                                        </b-form-checkbox>
                                    </b-form-checkbox-group>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                </div>

                <!-- DATA PENDUKUNG -->
                <div class="section-card">
                    <div class="section-card-header">
                        <span class="section-card-title">DATA PENDUKUNG</span>
                    </div>
                    <div class="section-card-body">
                        <b-button class="btn-pill-primary mb-3" @click="addFotoPendukung" name="fotoPendukungAddBtn">
                            <i class="fa fa-plus mr-1"></i> Foto Pendukung
                        </b-button>
                        <div class="text-danger small mb-3" v-show="fotoPendukungError">* Foto Pendukung Maksimal 6 Foto</div>
                        <FotoPendukung 
                            v-for="item in input.foto" 
                            v-bind:key="item.index" 
                            :fotoPendukung="item" 
                            :length="input.foto.length" 
                            :minLength="minLengthFotoPendukung"
                            @remove="removeFotoPendukung"
                            @showModalCam="openModalCam" 
                            @showModalPreview="openModalPreview"
                        />
                        <div class="small text-muted mt-2">
                            * Foto Pendukung maksimal 6 foto.
                        </div>
                    </div>
                </div>

                <!-- ALASAN PERUBAHAN -->
                <div class="section-card">
                    <div class="section-card-header">
                        <span class="section-card-title">ALASAN PERUBAHAN</span>
                    </div>
                    <div class="section-card-body">
                        <b-form-group label="Keterangan/ Alasan Perubahan">
                            <b-form-textarea
                                id="textarea"
                                v-model="input.alasanPerubahan" name="alasanPerubahan"
                                rows="3"
                                max-rows="6"
                                required
                            ></b-form-textarea>
                        </b-form-group>
                    </div>
                </div>

                <!-- SUBMIT ACTION -->
                <div class="d-flex justify-content-end mb-4">
                    <b-button type="submit" name="gadaiUpdateBtn" class="btn-pill-primary" style="padding: 10px 32px !important; font-size: 15px !important;">
                        Update
                    </b-button>
                </div>
            </b-form>
        </div>
        <ModalConfirm id="modal-confirm-edit" title="Confirm Edit Gadai Elektronik" alertMessage="Perubahan ini akan diperiksa dan disetujui oleh KCS terlebih dahulu sebelum data gadai diubah" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mengubah gadai elektronik ini?" @submit="onSubmit" />
        <ModalWebCam @photoTaken="setResult"  />
        <ModalPreview :fotoPreview="activeFotoPreview" />
    </div>
</template>

<script>
import FotoPendukung from '../../../components/webcam/FotoPendukung'
import ModalWebCam from '../../../components/webcam/ModalWebCam'
import ModalPreview from '../../../components/webcam/ModalPreview'

export default {
    name: 'edit-gadai-elektronik',
    components: {
        FotoPendukung,
        ModalWebCam,
        ModalPreview
    },
    data(){
        return{
            id: null,
            initStatus: 0,
            isSubmitting: false,
            isLoading: true,
            dataElek: {
                anggota: [],
                barang: {
                    foto: [],
                },
            },
            input:{
                foto: [],
                kelengkapanGadai: [],
                spesifikasiJenis:[],
                spesifikasiMerk:[],
                alasanPerubahan: "",
                tahunGadai: {},
                dataKondisi: null
            },

            indexFotoPendukung: 0,
            fotoPendukungError: false,
            activeFotoPendukungIndex: null,
            activeFotoPreviewIndex: null,
            minLengthFotoPendukung: 0,
            activeFotoPreview: "",

            optElekJenis: [],
            optElekMerk: [],
            optElekTipe: [],
            optElekTahun: [],
            optElekKondisi: [],
            optElekWarna: [],
            optKelengkapanBarang: [],
            optElekSpekJenis: {
				penambahan : [],
				pengurangan : []
			},
            optElekSpekMerk: {
				penambahan : [],
				pengurangan : []
			},

        }
    }, 
    watch: {
        'dataElek.barang.jenis': function(newVal) {
            console.log(newVal)
            if(this.isLoading != true){
                this.optElekMerk = []
                this.dataElek.barang.merk = null

                this.optKelengkapanBarang = []
                this.input.kelengkapanGadai = []

                this.optElekSpekJenis = {
					penambahan : [],
					pengurangan : []
				}
                this.input.spesifikasiJenis = []

                if(newVal == null) { return }

                // Lookup Merk
                this.$axios.get(`barang-merk/jenis/${newVal.id}`).then(response => {
                    this.optElekMerk = response.data
                })

                // Lookup Kelengkapan Barang
                this.$axios.get(`barang-jenis/kelengkapan?jenisId=${newVal.id}`).then(response => {
                    this.optKelengkapanBarang = response.data
                })

                // Lookup Spek Jenis
                this.$axios.get(`barang-jenis/spesifikasi?jenisId=${newVal.id}`).then(response => {
                    this.optElekSpekJenis = response.data
                })
            }

        },
        'dataElek.barang.merk': function(newVal) {

            if(this.isLoading != true){
                this.optElekTipe = []
                this.dataElek.barang.tipe = null

                this.optElekSpekMerk = {
					penambahan : [],
					pengurangan : []
				}
                this.input.spesifikasiBarangMerk = []

                if(newVal == null) { return }

                // Lookup Tipe
                this.$axios.get(`barang-tipe/merk/${newVal.id}`).then(response => {
                    this.optElekTipe = response.data
                })

                // Lookup Spek Merk
                this.$axios.get(`barang-merk/spesifikasi?merkId=${newVal.id}`).then(response => {
                    this.optElekSpekMerk = response.data
                })
            }

        },
        'dataElek.barang.tipe': function(newVal) {

            if(this.isLoading != true){
                this.optElekTahun = []
                this.input.tahunGadai = null

                this.optElekKondisi = []
                this.input.dataKondisi = null

                if(newVal == null) { return }

                // Lookup Tahun
                this.$axios.get(`barang-tipe/tahun/${newVal.id}`).then(response => {
                    this.optElekTahun = response.data
                })

                // Lookup Kondisi
                this.$axios.get(`barang-tipe/kondisi/${newVal.id}`).then(response => {

                    this.optElekKondisi = response.data.map(item => {
                        return { value: item.id, text: item.name }
                    })

                })
            }

        },
    },
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.id = this.$route.params.id

            let getJenisElek = this.$axios.get("barang-jenis/elektronik").then(response => {
                this.optElekJenis = response.data
                console.log(response.data)
            })

            let getWarnaElek = this.$axios.get("gadai/warna").then(response => {
                this.optElekWarna = response.data.map(item => { return { value: item.id, text: item.name } })
            })

            let getEditElek = this.$axios.get(`gadai/daftar-gadai/${this.id}/edit`).then(response => {
                this.dataElek= response.data
                console.log(response.data)
                
                //----------------- Inisialisasi Data Foto -----------------
                
                for (var x of this.dataElek.foto) {
                    this.input.foto.push({
                        index: this.indexFotoPendukung, 
                        id: x.id, 
                        fotoBarangPendukung: null,
                        fotoBarangPendukungBase64: null,
                        activeFotoPendukungBase64: this.$baseFilePath+x.name,
                        urlFotoBarangPendukung: x.name,
                    })
                    this.indexFotoPendukung++
                }

                if(this.dataElek.barang.jenis.id != null){
                    this.$axios.get(`barang-jenis/kelengkapan?jenisId=${this.dataElek.barang.jenis.id}`).then(response => {
                        this.optKelengkapanBarang = response.data
                        //----------------- Inisialisasi Kelengkapn -----------------
                        for (var x of this.dataElek.barang.kelengkapan) {
                            let idx = this.optKelengkapanBarang.findIndex(item => item.name == x.trim());
                            if(idx != -1) this.input.kelengkapanGadai.push(this.optKelengkapanBarang[idx])
                        }
                    })
                    this.$axios.get(`barang-jenis/spesifikasi?jenisId=${this.dataElek.barang.jenis.id}`).then(response => {
                        this.optElekSpekJenis = response.data
                        for (var x of this.dataElek.barang.spesifikasi) {
                            //----------------- Inisialisasi Spesifikasi Jenis -----------------
                            
                            let idxSpekJenisPenambahan = this.optElekSpekJenis.penambahan.findIndex(item => item.id == x.id);
                            if(idxSpekJenisPenambahan >= 0){
                                this.input.spesifikasiJenis.push(this.optElekSpekJenis.penambahan[idxSpekJenisPenambahan].id)
							}
							let idxSpekJenisPengurangan = this.optElekSpekJenis.pengurangan.findIndex(item => item.id == x.id);
                            if(idxSpekJenisPengurangan >= 0){
                                this.input.spesifikasiJenis.push(this.optElekSpekJenis.pengurangan[idxSpekJenisPengurangan].id)
                            }
                        }
                    })
                    this.$axios.get(`barang-merk/jenis/${this.dataElek.barang.jenis.id}`).then(response => {
                        this.optElekMerk = response.data
                        if(this.dataElek.barang.merk.id != null){
                            this.$axios.get(`barang-merk/spesifikasi?merkId=${this.dataElek.barang.merk.id}`).then(response => {
                                this.optElekSpekMerk = response.data
                                for (var x of this.dataElek.barang.spesifikasi) {
                                    //----------------- Inisialisasi Spesifikasi Merk -----------------
                                    let idxSpekMerkPenambahan = this.optElekSpekMerk.penambahan.findIndex(item => item.id == x.id);
                                    if(idxSpekMerkPenambahan >= 0){
                                        this.input.spesifikasiMerk.push(this.optElekSpekMerk.penambahan[idxSpekMerkPenambahan].id)
									}
									let idxSpekMerkPengurangan = this.optElekSpekMerk.pengurangan.findIndex(item => item.id == x.id);
                                    if(idxSpekMerkPengurangan >= 0){
                                        this.input.spesifikasiMerk.push(this.optElekSpekMerk.pengurangan[idxSpekMerkPengurangan].id)
                                    }
                                }
                            })
                            this.$axios.get(`barang-tipe/merk/${this.dataElek.barang.merk.id}`).then(response => {
                                this.optElekTipe = response.data
                                if(this.dataElek.barang.tipe.id !=null){
                                    this.$axios.get(`barang-tipe/tahun/${this.dataElek.barang.tipe.id}`).then(response => {
                                        this.optElekTahun = response.data
                                        let idxTahunGadai = this.optElekTahun.findIndex(item=>item.name == this.dataElek.barang.tahun);
                                        this.input.tahunGadai=this.optElekTahun[idxTahunGadai]
                                    })
                                    this.$axios.get(`barang-tipe/kondisi/${this.dataElek.barang.tipe.id}`).then(response => {
                                        this.optElekKondisi = response.data.map(item => {
                                            return { value: item.id, text: item.name }
                                        })
                                        let dataOptKondisi = JSON.parse(JSON.stringify(this.optElekKondisi))
                                        let dataGradeKondisi = dataOptKondisi.filter(item=> item.text == this.dataElek.barang.gradeKondisi.name)
                                        if(dataGradeKondisi.length != 0){
                                            this.input.dataKondisi = dataGradeKondisi[0].value
                                        }else{
                                            this.input.dataKondisi = null
                                        }
                                    })
                                }
                            })
                        }
                    })
                }
                
            })

            Promise.all([getJenisElek, getWarnaElek, getEditElek]).then(() => {
                this.initStatus = 1
                this.isLoading = false
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        },

        //----------------- Fungsi Submit Data -----------------

        onSubmit(){
            if(this.dataElek.barang.jenis.name.startsWith('Lainnya')){
                this.$helper.toastErr(this, "Jenis barang tidak boleh lainnya")
            }else if(this.dataElek.barang.jenis.id == null){
                this.$helper.toastErr(this, "Mohon isi jenis terlebih dahulu")
            }else if(this.dataElek.barang.merk.id == null){
                this.$helper.toastErr(this, "Mohon isi merk terlebih dahulu")
            }else if(this.dataElek.barang.tipe.id == null){
                this.$helper.toastErr(this, "Mohon isi tipe terlebih dahulu")
            }else{
                let payload = new FormData()
                this.id = this.$route.params.id

                //----------------- Append Data Gadai -----------------

                payload.append("id", this.id)
                payload.append("jenisPinjamanId", 1) // MARK HARDCODE
                payload.append("jenisBarangId", this.dataElek.barang.jenis.id)
                payload.append("merkId", this.dataElek.barang.merk.id)
                payload.append("tipeId", this.dataElek.barang.tipe.id)
                payload.append("kondisiId", this.input.dataKondisi)
                payload.append("warnaId", this.dataElek.barang.warna.id)
                payload.append("imeiSn", this.dataElek.barang.noImei)
                payload.append("keterangan", this.dataElek.barang.keterangan)
                payload.append("keteranganRevisi ", this.input.alasanPerubahan)

                if(this.$helper.isNotNullAndNotEmpty(this.dataElek.barang.password)){
                    payload.append("password", this.dataElek.barang.password)
                }
                
                if(this.$helper.isNotNullAndNotEmpty(this.input.tahunGadai)) {
                    payload.append("tahunId", this.input.tahunGadai.id)
                }

                // Append all checked spesifikasi
                for(let spek of this.input.spesifikasiJenis) {
                    payload.append("spesifikasiId", spek)
                }

                for(let spek of this.input.spesifikasiMerk) {
                    payload.append("spesifikasiId", spek)
                }

                // Kelengkapan
                if(this.input.kelengkapanGadai.length != 0) {

                    this.input.kelengkapanGadai.forEach(item => {
                        payload.append("kelengkapan", item.name)
                    })

                }

                // Upload photo only if on final step
                let jsonFoto = []
                this.input.foto.forEach(function(entry) {
                    jsonFoto.push(entry.activeFotoPendukungBase64)  
                })
                payload.append("foto", JSON.stringify(jsonFoto))
                
                //----------------- Submit Semua Data -----------------

                this.isSubmitting = true

                this.$axios.post(`gadai-crud/edit/${this.id}/elektronik`, payload, { timeout: 300000 }).then(response => {

                    if(response.data.name == 'REFRESH_KONDISI'){
                        this.$helper.toastErr(this, "Harga barang baru saja diperbarui HO. Silahkan isi ulang Kondisi / Grade Barang!")
                        this.input.dataKondisi = null
                        this.$axios.get(`barang-tipe/kondisi/${this.dataElek.barang.tipe.id}`).then(response => {

                            this.optElekKondisi = response.data.map(item => {
                                return { value: item.id, text: item.name }
                            })

                        })
                    }else{
                        this.initStatus = 1
                        this.$helper.setFlash(`Perubahan gadai berhasil diajukan!`)
                        if(this.$route.path.includes("inquiry-faktur")){
                            let path = this.$route.path.split('/')
                            path.pop()
                            path.pop()
                            path = path.join("/")
                            this.$router.push({ path })
                        }else{
                            let path = this.$route.path.split('/')
                            path.pop()
                            path = path.join("/")
                            this.$router.push({ path })
                        }
                    }
                })
                .catch(error => {
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.isSubmitting = false
                })
            }

        },

        //----------------- Fungsi Tambah Hapus Data Foto Pendukung -----------------

        addFotoPendukung() {
            if(this.input.foto.length < 6){
                this.input.foto.unshift({ 
                    index: this.indexFotoPendukung, 
                    id: 0, 
                    fotoBarangPendukung: null,
                    fotoBarangPendukungBase64: null,
                    activeFotoPendukungBase64: null,
                    urlFotoBarangPendukung: null
                })
                this.indexFotoPendukung++;
            }else{
                this.fotoPendukungError = true;
            }
        },

        removeFotoPendukung(index) {
            this.input.foto = this.input.foto.filter(item => item.index != index)
            this.fotoPendukungError = false;
        },

        //----------------- Fungsi Lain -----------------

        openModalConfirm(){
            if(this.dataElek.barang.jenis.name == 'Handphone' && this.dataElek.barang.noImei.length != 15){
                this.$helper.toastErr(this, "Apabila jenis barangnya Handphone, IMEI harus 15 karakter")
            }else{
                this.$bvModal.show("modal-confirm-edit")
            }
        },

        openModalCam(index){
            this.activeFotoPendukungIndex = index
            this.$bvModal.show("modal-ambil-foto")
        },

        openModalPreview(index){
            this.activeFotoPreviewIndex = index
            let idx = this.input.foto.findIndex(item => item.index == this.activeFotoPreviewIndex);
            this.activeFotoPreview = this.input.foto[idx].activeFotoPendukungBase64
            this.$bvModal.show("modal-preview-foto")
        },

        async setResult(result){
            //letakin ke null masing2
            var newResult = await this.$helper.resizeImage(result)
            let idx = this.input.foto.findIndex(item => item.index == this.activeFotoPendukungIndex);
            this.input.foto[idx].fotoBarangPendukungBase64 = newResult
            this.input.foto[idx].activeFotoPendukungBase64 = newResult
        },
    },
    created(){
        this.init()
    }
}
</script>
